export type InboxFilterKey =
  | 'all'
  | 'new'
  | 'needs_reply'
  | 'draft'
  | 'closed'
  | 'trash';

export const INBOX_FILTERS: { key: InboxFilterKey; label: string }[] = [
  { key: 'all', label: 'All Tickets' },
  { key: 'new', label: 'New Inquiries' },
  { key: 'needs_reply', label: 'Needs Reply' },
  { key: 'draft', label: 'Draft Replies' },
  { key: 'closed', label: 'Closed' },
  { key: 'trash', label: 'Trash' },
];

export type SenderType = 'customer' | 'agent' | 'system';

export type ThreadStatus = 'new' | 'needs_reply' | 'open' | 'closed';

export type InboxMessage = {
  id: string;
  threadId: string;
  fromName: string;
  fromEmail?: string;
  fromType: SenderType;
  body: string;
  createdAt: string; // ISO
};

export type InboxDraft = {
  threadId: string;
  body: string;
  updatedAt: string; // ISO
};

export type InboxThread = {
  id: string;
  subject?: string;
  customerName: string;
  customerEmail?: string;

  status: ThreadStatus;
  lastMessageAt: string; // ISO
  lastMessageSnippet: string;
  lastMessageFrom: SenderType;

  unreadCount: number;

  deletedAt?: string | null; // soft delete
  draft?: InboxDraft | null;
};
